module.exports = __webpack_public_path__ + "img/logo_old.37bb1803.png";